/**
 * Checks if a URL is valid by sending a HEAD request to it.
 * @param {string} url - The URL to validate.
 * @returns {Promise<boolean>} A promise that resolves to true if the URL is valid, false otherwise.
 */
async function isValidUrl(url?: string): Promise<boolean> {
  try {
    if (!url) return false;
    await fetch(url, { method: 'HEAD' });
    return true;
  } catch (error) {
    return false;
  }
}

export default isValidUrl;
